export default __webpack_public_path__ + "static/media/rbi_alt.32788394.png";